import React, { Component } from 'react'
import './index.css'
import { Layout, Affix, Button, Icon, Anchor } from 'antd';
import { withTranslation } from 'react-i18next';
const { Content } = Layout;
class PolicyMY extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // top: 85,
            // bottom: 10,
            // offsetTop: 80
        };
    }
    render() {
        const { t } = this.props
        return (
        <Content className="q-content-wrapper">
            <div className="q-main " style={{ padding: '65px 0 20px 0px' }}>
                <Content className="q-detail-content q-policy" >
                <div className="right-content" id="soft-introduce">
                    <h2>{t('policyTitle')}</h2>
                    <div className="right-content-box" >
                        <p>{t('policyContent')}</p>
                    </div>
                    <div className="right-content-box" >
                        <p className="headTitle">{t('policyItem01')}</p>
                        <p>{t('policyItem01_1')}</p>
                        <p>{t('policyItem01_2')}</p>
                        <p>{t('policyItem01_3')}</p>
                    </div>
                    <div className="right-content-box" >
                        <p className="headTitle">{t('policyItem02')}</p>
                        <p>{t('policyItem02_1')}</p>
                        <p>{t('policyItem02_2')}</p>
                    </div>
                    <div className="right-content-box" >
                        <p className="headTitle">{t('policyItem03')}</p>
                        <p>{t('policyItem03_1')}</p>
                    </div>
                    <div className="right-content-box" >
                        <p className="headTitle">{t('policyItem04')}</p>
                        <p>{t('policyItem04_1')}</p>
                    </div>
                    <div className="right-content-box" >
                        <p className="headTitle">{t('policyItem05')}</p>
                        <p>{t('policyItem05_0')}</p>
                        <p>{t('policyItem05_1')}</p>
                        <p>{t('policyItem05_2')}</p>
                        <p>{t('policyItem05_3')}</p>
                        <p>{t('policyItem05_4')}</p>
                        <p>{t('policyItem05_5')}</p>
                        <p>{t('policyItem05_6')}</p>
                        <p>{t('policyItem05_7')}</p>
                        <p>{t('policyItem05_8')}</p>
                    </div>
                    <div className="right-content-box" >
                        <p className="headTitle">{t('policyItem06')}</p>
                        <p>{t('policyItem06_1')}</p>
                    </div>
                    <div className="right-content-box" >
                        <p className="headTitle">{t('policyItem07')}</p>
                        <p className="headTitle">{t('policyItem07_1')}</p>
                        <p>{t('policyItem07_2')}</p>
                        <ul>
                            <p>{t('policyItem07_3')}</p>
                            <p>{t('policyItem07_4')}</p>
                        </ul>
                        <p>{t('policyItem07_5')}</p>
                        <p>{t('policyItem07_6')}</p>
                        <p>{t('policyItem07_7')}</p>
                        <p>{t('policyItem07_8')}</p>
                        <ul>
                            <p>{t('policyItem07_9')}</p>
                            <p>{t('policyItem07_10')}</p>
                            <p>{t('policyItem07_11')}</p>
                        </ul>
                        <p>{t('policyItem07_12')}</p>
                        <p>{t('policyItem07_13')}</p>
                        <p>{t('policyItem07_14')}</p>
                        <p>{t('policyItem07_15')}</p>
                    </div>
                    <div className="right-content-box" >
                        <p className="headTitle">{t('policyItem08')}</p>
                        <p>{t('policyItem08_1')}</p>
                    </div>
                    <div className="right-content-box" >
                        <p className="headTitle">{t('policyItem09')}</p>
                        <p>{t('policyItem09_1')}</p>
                    </div>
                </div>
               </Content>
            </div>
        </Content>
        )
    }
}
export default withTranslation()(PolicyMY)